import { selectors } from "./selectors.js";
const reducer = (state, action) => {
  switch (action.type) {
    case "setPurchaseType": {
      const { purchaseType } = action.payload;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          purchaseType
        }
      };
    }
    case "setDeliveryInterval": {
      const { deliveryInterval } = action.payload;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          subscriptionPurchaseConfigurations: {
            ...state.configurations.subscriptionPurchaseConfigurations,
            deliveryInterval
          }
        },
        configurator: {
          ...state.configurator,
          deliveryInterval: {
            showError: false
          }
        }
      };
    }
    case "setQuantity": {
      const { quantity } = action.payload;
      return {
        ...state,
        configurations: {
          ...state.configurations,
          quantity
        }
      };
    }
    case "triggerErrors": {
      const isConfiguratorValid = selectors.isConfiguratorValid(state);
      if (isConfiguratorValid) {
        return state;
      }
      const isDeliveryIntervalValid = selectors.isDeliveryIntervalValid(state);
      const { invalidSubmissionsCount: previousCount, deliveryInterval } = state.configurator;
      const newCount = (previousCount || 0) + 1;
      return {
        ...state,
        configurator: {
          ...state.configurator,
          invalidSubmissionsCount: newCount,
          deliveryInterval: {
            ...deliveryInterval,
            showError: isDeliveryIntervalValid === false
          }
        }
      };
    }
    case "resetErrors": {
      return {
        ...state,
        configurator: {
          ...state.configurator,
          invalidSubmissionsCount: void 0,
          deliveryInterval: {
            ...state.configurator.deliveryInterval,
            showError: false
          }
        }
      };
    }
    default:
      return state;
  }
};
export {
  reducer
};
//# sourceMappingURL=reducer.js.map
